import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type HotelSettingsCompetitorsBenchmarkCompsetBuilderRoute from 'lumen/routes/hotel/settings/competitors/benchmark/compset/builder';
import type { ModelFrom } from 'lumen/utils/routes';

export default class HotelSettingsCompetitorsBenchmarkCompsetBuilderGenerateRoute extends Route {
  @service declare router: Services['router'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  model() {
    const parentModel = this.modelFor(
      'hotel.settings.competitors.benchmark.compset.builder',
    ) as ModelFrom<HotelSettingsCompetitorsBenchmarkCompsetBuilderRoute>;

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const transitionToProposalsRoute = () =>
      // Use legacyTransitionTo to avoid the parent model refreshing
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
      this.router.legacyTransitionTo(
        'hotel.settings.competitors.benchmark.compset.builder.proposals',
      );

    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    parentModel.proposedCompsets.perform(transitionToProposalsRoute);

    return parentModel;
  }
}
